import useShowDialogAlert from "components/DialogAlert/utils/hooks/useDialogAlert";

const useDialogShowActionResource = () => {
    const dialogShowToggleActivationResource = useShowDialogAlert();
    const dialogShowDeletionResource = useShowDialogAlert();
    return {
        dialogShowToggleActivationResource,
        dialogShowDeletionResource
    };
}
export default useDialogShowActionResource;